module.exports = __webpack_public_path__ + "static/media/pressure-monitor-online.0fd37eab.svg";